const getOrderNo = (str) => {
    let queryObj = {};
    if (str.indexOf('?') !== -1) {
        let arr1 = str.split('?');
        let str1 = arr1[1];
        let str2 = '';
        let arr2 = arr1.slice(1);
        let arr3 = arr2.map(item => {
            let newItem = item;
            if (item.indexOf('#') !== -1) {
                newItem = item.split('#')[0];
            }
            return newItem;
        })
        str2 = arr3.join('&');
        const arr = str2.split('&');
        for (let obj of arr) {
            queryObj[obj.split('=')[0]] = obj.split('=')[1];
        }
    }
    console.log('queryObj', queryObj);
    return queryObj;
}

export default getOrderNo;